import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StringPiPipe, LinebreaksPipe } from '../pipes/util.pipe';
import { AvdProvisioningStatusComponent } from './avd-provisioning-status/avd-provisioning-status.component';
import { VdiApprovalDashboardComponent } from './vdi-approval-dashboard/vdi-approval-dashboard.component';
import { NgZorroAntdModule } from '../modules/app-common/ng-zorro-antd.module';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';

@NgModule({
    declarations: [
        StringPiPipe,
        LinebreaksPipe,
        AvdProvisioningStatusComponent,
        VdiApprovalDashboardComponent
    ],
    imports: [
        CommonModule,
        NgZorroAntdModule,
        NzMessageModule,
        NzModalModule
    ],
    exports: [
        StringPiPipe,
        LinebreaksPipe,
        AvdProvisioningStatusComponent,
        VdiApprovalDashboardComponent
    ]
})
export class CommoncomponentsModule { }
